import "./privacy.css";

export const RefundPolicy = ()=> {
  return (
   <>
    <div className="privacy-wrapper">
      <div className="privacy-container">

        <h1 className="main-title">Cancellation and Refund Policy</h1>

        <p>
          This Cancellation and Refund Policy outlines the terms and conditions governing cancellations and refunds for services purchased from BusinessBay.
        </p>

        <p>
          By accessing or using our services, you agree to the terms outlined below.
        </p>

        <h2>Important Notice: No Refund Policy</h2>

        <p>
          Business Bay does not offer refunds for any products or services once a transaction has been completed.
        </p>

        <p>
          All payments made through our platform are final and non-refundable. Customers are solely responsible for the use of their own funds through the card services facilitated by Business Bay.
        </p>

        <h2>Service Description</h2>

        <p>
          Business Bay provides access to card services and related tools that allow customers to manage and use their own funds. Business Bay does not hold customer funds, nor do we act as a bank, financial institution, or money service provider.
        </p>

        <p>
          Our role is strictly limited to facilitating access to the card platform and related service features.
        </p>

        <h2>Order and Subscription Cancellations</h2>

        <ul>
          <li>Orders: Once a service order is confirmed and processed, it cannot be cancelled.</li>
          <li>Subscriptions: Customers may cancel any active subscription to halt future renewals, but no refunds will be issued for any prior or current billing cycle.</li>
        </ul>

        <h2>Non-Refundable Services</h2>

        <p>
          All services offered on Business Bay are non-refundable, including but not limited to:
        </p>

        <ul>
          <li>Card issuance fees</li>
          <li>Platform access fees</li>
          <li>Subscription fees</li>
          <li>Account setup or activation charges</li>
          <li>Any service-related transaction fees</li>
        </ul>

        <p>
          These charges are clearly disclosed at the time of purchase.
        </p>

        <h2>Customer Responsibility</h2>

        <p>
          By using Business Bay's services, customers acknowledge and agree that:
        </p>

        <ul>
          <li>All transactions are initiated using their own funds.</li>
          <li>Business Bay is not liable for any misused, unauthorized, or unintended transactions.</li>
          <li>It is the customer’s responsibility to ensure correct use of the platform.</li>
        </ul>

        <h2>Exceptions</h2>

        <p>
          Refunds or service credits will only be considered under the following exceptional conditions:
        </p>

        <ul>
          <li>The service was not delivered at all due to a verifiable technical issue caused by Business Bay.</li>
          <li>The transaction was fraudulently processed without the customer's consent and verified as such by our compliance team.</li>
        </ul>

        <p>
          All exception claims are subject to internal investigation and approval.
        </p>

        <h2>Changes to Policy</h2>

        <p>
          Business Bay reserves the right to modify or update this Cancellation and Refund Policy at any time. Updates become effective once posted on the Website. Customers are advised to review this policy periodically.
        </p>

        <h2>Contact Information</h2>

        <p>
          For any questions or concerns regarding this policy, please contact our customer support team:
        </p>

        <p>
          📧 <a href="mailto:info@businessbay.io" className="email">info@businessbay.io</a>
        </p>

      </div>
    </div>
    </>
  );
}